var ReservationsComponent = angular.module('RessieApp.components.reservations', [
  'RessieApp.components.reservations.online'
]);
